import React from 'react'
import Products from '../Pages/Products'
import Header from '../Components/Header'
import Footer from '../Components/Footer'

function ProductsLayout() {
  return (
    <>
    <Header />
    <Products />
    <Footer />
    </>
  )
}

export default ProductsLayout